var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-startPractice" }, [
    _c(
      "div",
      { staticClass: "leftBox", attrs: { id: "leftBox" } },
      [
        _c("i", {
          staticClass: "iconfont iconfanhui",
          on: {
            click: function ($event) {
              return _vm.$router.go(-1)
            },
          },
        }),
        _c("div", { staticClass: "grade" }, [
          _vm._v(" " + _vm._s(_vm.otherInfoDTO.score) + " "),
          _c("span", { staticClass: "f20" }, [_vm._v("分")]),
        ]),
        _vm.topicTypeZn === "zhi_neng_lian_xi"
          ? _c(
              "div",
              { staticClass: "title" },
              _vm._l(_vm.otherInfoDTO.title, function (item, index) {
                return _c("span", { key: index }, [
                  _vm._v(_vm._s(item)),
                  _vm.otherInfoDTO.title.length - 1 !== index
                    ? _c("em")
                    : _vm._e(),
                ])
              }),
              0
            )
          : _c("div", [
              _c(
                "div",
                { staticClass: "title" },
                _vm._l(_vm.otherInfoDTO.title, function (item, index) {
                  return _c("span", { key: index }, [
                    _vm._v(_vm._s(item)),
                    _vm.otherInfoDTO.title.length - 1 !== index
                      ? _c("em")
                      : _vm._e(),
                  ])
                }),
                0
              ),
            ]),
        _vm._l(_vm.topicLists, function (itemTo, index) {
          return _c(
            "div",
            { key: index, staticClass: "topicDivButton", class: _vm.fontClass },
            [
              _c(
                "div",
                {
                  staticClass: "topicDiv",
                  attrs: {
                    id: itemTo.question_style != 6 && `id_${itemTo.sort}`,
                  },
                },
                [
                  itemTo.question_style === 1
                    ? _c("ChoiceOne", {
                        attrs: { datas: itemTo, isDisabled: _vm.isDisabled },
                        on: {
                          next: function ($event) {
                            return _vm.saveAnswer(itemTo)
                          },
                        },
                      })
                    : _vm._e(),
                  itemTo.question_style === 2
                    ? _c("Judge", {
                        attrs: { datas: itemTo, isDisabled: _vm.isDisabled },
                        on: {
                          next: function ($event) {
                            return _vm.saveAnswer(itemTo)
                          },
                        },
                      })
                    : _vm._e(),
                  itemTo.question_style === 3
                    ? _c("ChoiceMultiple", {
                        attrs: { datas: itemTo, isDisabled: _vm.isDisabled },
                        on: {
                          next: function ($event) {
                            return _vm.saveAnswer(itemTo)
                          },
                        },
                      })
                    : _vm._e(),
                  itemTo.question_style === 4
                    ? _c("FillBlank", {
                        attrs: { datas: itemTo, isDisabled: _vm.isDisabled },
                        on: {
                          next: function ($event) {
                            return _vm.saveAnswer(itemTo)
                          },
                        },
                      })
                    : _vm._e(),
                  itemTo.question_style === 5
                    ? _c("Subjective", {
                        attrs: { datas: itemTo, isDisabled: _vm.isDisabled },
                        on: {
                          next: function ($event) {
                            return _vm.saveAnswer(itemTo)
                          },
                        },
                      })
                    : _vm._e(),
                  itemTo.question_style !== 6
                    ? _c("QuestionAnalysis", {
                        attrs: {
                          analysisDatas: itemTo,
                          makeType: _vm.otherInfoDTO.make_type,
                          course_id: _vm.otherInfoDTO.course_id,
                        },
                        on: { noteChange: _vm.getDatas },
                      })
                    : _vm._e(),
                  itemTo.question_style === 6
                    ? _c(
                        "div",
                        [
                          _c("div", {
                            staticClass: "questionAskTitle",
                            attrs: { id: "questionAskTitle" },
                            domProps: { innerHTML: _vm._s(itemTo.content) },
                          }),
                          itemTo.audio_url
                            ? _c(
                                "div",
                                { staticClass: "audioDiv" },
                                _vm._l(
                                  itemTo.audio_url.split(","),
                                  function (itemAudio, indexAudio) {
                                    return _c(
                                      "audio",
                                      {
                                        key: indexAudio,
                                        staticClass: "sourceAudio",
                                        attrs: { controls: "controls" },
                                      },
                                      [
                                        _c("source", {
                                          attrs: {
                                            src: itemAudio,
                                            type: "audio/ogg",
                                          },
                                        }),
                                        _vm._v(
                                          " Your browser does not support the audio element. "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm._l(itemTo.child, function (item, index) {
                            return _c(
                              "div",
                              { key: index, attrs: { id: `id_${item.sort}` } },
                              [
                                item.question_style === 1
                                  ? _c("ChoiceOne", {
                                      attrs: {
                                        datas: item,
                                        isDisabled: _vm.isDisabled,
                                      },
                                      on: {
                                        next: function ($event) {
                                          return _vm.saveAnswer(item)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                item.question_style === 4
                                  ? _c("FillBlank", {
                                      attrs: {
                                        datas: item,
                                        isDisabled: _vm.isDisabled,
                                      },
                                      on: {
                                        next: function ($event) {
                                          return _vm.saveAnswer(item)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                item.question_style === 2
                                  ? _c("Judge", {
                                      attrs: {
                                        datas: item,
                                        isDisabled: _vm.isDisabled,
                                      },
                                      on: {
                                        next: function ($event) {
                                          return _vm.saveAnswer(item)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                item.question_style === 3
                                  ? _c("ChoiceMultiple", {
                                      attrs: {
                                        datas: item,
                                        isDisabled: _vm.isDisabled,
                                      },
                                      on: {
                                        next: function ($event) {
                                          return _vm.saveAnswer(item)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                itemTo.question_style === 5
                                  ? _c("Subjective", {
                                      attrs: {
                                        datas: itemTo,
                                        isDisabled: _vm.isDisabled,
                                      },
                                      on: {
                                        next: function ($event) {
                                          return _vm.saveAnswer(itemTo)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _c("QuestionAnalysis", {
                                  attrs: {
                                    analysisDatas: item,
                                    course_id: _vm.otherInfoDTO.course_id,
                                    makeType: _vm.otherInfoDTO.make_type,
                                  },
                                  on: { noteChange: _vm.getDatas },
                                }),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        }),
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "mat20" },
      [
        _c("AnswerSheet", {
          attrs: { isAnalysis: true, datas: _vm.topicCard, total: _vm.total },
          on: { change: _vm.jumpTo, submit: _vm.submit },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }